export default __webpack_public_path__ + "static/media/ic_svc_health.d8d8cbb3.png";